import type { ReactElement } from 'react';
import { AlertTriangle } from 'lucide-react';

export const UnavailablePaymentMethodNotice = (): ReactElement => (
  <div className='flex items-start gap-2 rounded-md border border-warning-border bg-warning-light p-4 text-sm text-warning-foreground' role='status' aria-live='polite'>
    <AlertTriangle className='mt-0.5 size-4 shrink-0' aria-hidden='true' />
    <span>Die Zahlungsart ist nicht verfügbar. Bitte wenden Sie sich an den Support, um die Rechnung manuell zu klären.</span>
  </div>
);
